export default __webpack_public_path__ + "static/media/baby-carriage-solid.963113dc.svg";